import moment from "moment";
import { Badge } from "shared";
import { Order } from "types/OrdersTypes";

export const MobileColumns = () => {
  return [
    {
      title: "",
      key: "mobile",
      render: (value: any, record: Order, index: number) => {
        return (
          <div className="mobile-row">
            <div className="mobile-row__item">
              <span className="mobile-row__label">Data realizacji:</span>
              <span className="mobile-row__value">
                {moment(record.realizationDate).format("DD.MM.YYYY, HH:mm")}
              </span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Data pobrania:</span>
              <span className="mobile-row__value">
                {moment(record.createdAt).local().format("DD.MM.YYYY, HH:mm")}
              </span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Data wygaśnięcia:</span>
              <span className="mobile-row__value">
                {record.deletedAt
                  ? moment(record.deletedAt).local().format("DD.MM.YYYY, HH:mm")
                  : "-"}
              </span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Załadunek:</span>
              <span className="mobile-row__value">{record.loadingLocation}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Rozładunek:</span>
              <span className="mobile-row__value">{record.unloadingLocation}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Transport:</span>
              <span className="mobile-row__value">{record.transport}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Cena całkowita:</span>
              <span className="mobile-row__value price">{`${record.price} zł`}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Masa:</span>
              <span className="mobile-row__value">{`${record.weight} t`}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Odległość:</span>
              <span className="mobile-row__value">{`${record.distance} km`}</span>
            </div>
            <div className="mobile-row__item">
              <span className="mobile-row__label">Status:</span>
              <span className="mobile-row__value">
                <Badge status={record.status} />
              </span>
            </div>
          </div>
        );
      },
    },
  ];
};

export const Columns = () => {
  let result = [
    {
      title: "Data realizacji",
      key: "realizationDate",
      width: 160,
      render: (value: any, record: Order, index: number) => {
        return moment(record.realizationDate).format("DD.MM.YYYY, HH:mm");
      },
    },
    {
      title: "Data pobrania",
      key: "createdAt",
      width: 140,
      render: (value: any, record: Order, index: number) => {
        return moment(record.createdAt).local().format("DD.MM.YYYY, HH:mm");
      },
    },
    {
      title: "Data wygaśnięcia",
      key: "deletedAt",
      width: 140,
      render: (value: any, record: Order, index: number) => {
        return record.deletedAt
          ? moment(record.deletedAt).local().format("DD.MM.YYYY, HH:mm")
          : "-";
      },
    },
    {
      title: "Załadunek",
      dataIndex: "loadingLocation",
      key: "loadingLocation",
      width: 140,
    },
    {
      title: "Rozładunek",
      dataIndex: "unloadingLocation",
      key: "unloadingLocation",
      width: 140,
    },
    {
      title: "Transport",
      dataIndex: "transport",
      key: "transport",
      width: 140,
    },
    {
      title: "Cena całkowita",
      width: 140,
      render: (value: any, record: Order, index: number) => {
        return <span className="price">{`${record.price} zł`}</span>;
      },
    },
    {
      title: "Masa",
      width: 50,
      render: (value: any, record: Order, index: number) => {
        return `${record.weight} t`;
      },
    },
    {
      title: "Odległość",
      width: 50,
      render: (value: any, record: Order, index: number) => {
        return `${record.distance} km`;
      },
    },
    {
      title: "Status",
      width: 200,
      render: (value: any, record: Order, index: number) => {
        return <Badge status={record.status} />;
      },
    },
  ];

  return result;
};
